export default  {
    height: '714',
    width: '1159',
    playerVars: {
      autoplay: 1,
    }
};